import type { FirestoreTimestamp } from '@rundown-studio/types'
import { parseISO } from 'date-fns'

/**
 * Coerce a date-ish value into a JS `Date`.
 *
 * Accepts the three shapes a persisted timestamp arrives as — an ISO string, a
 * `Date`, or a raw Firestore `Timestamp` — plus `null`/`undefined`. Returns
 * `undefined` for empty input so callers can guard. Firestore docs deserialize
 * as `Timestamp` (or ISO strings over the wire); the store/atoms don't always
 * convert them, so any `.getTime()` math must go through here first.
 *
 * @param {string | Date | FirestoreTimestamp | null | undefined} value
 * @return {Date | undefined}
 */
export function parseRundownDate(
  value?: string | Date | FirestoreTimestamp | null,
): Date | undefined {
  if (!value) return
  if (typeof value === 'string') return parseISO(value)
  if (value instanceof Date) return value
  return value.toDate()
}
